export default "__VITE_ASSET__Cwcag9wG__"